/* eslint-disable no-param-reassign */
import * as React from 'react';
import classNames from 'classnames';
import Navbar from '../../../common/Navbar/Navbar';
import CrossVendorIndicator from '../../../common/CrossVendorIndicator';

import {
  CameraFilled,
  CheckCircleFilled,
  CloseCircleFilled,
  InfoCircleOutlined,
} from '@ant-design/icons';

import { Table, Modal, message, Button, Col, Result } from 'antd';
import withStyles from 'react-jss';
import { getTripDetails, getTripDetailsMetadata } from '../../../api/tripDetails';
import Loader from '../../../common/Loader';
import {
  formatDateTime,
  getConsignmentTypePrettyName,
  getTaskTypePrettyName,
  parseMinuteSeconds,
} from '../../../utils/utils';
import {
  getRetailConsignmentStatus,
  getRetailInTripConsignmentStatus,
  tripStatusPrettyNames,
} from '../../../utils/consignmentUtils';

import DocumentTitle from 'react-document-title';
import { NAVBAR_HEIGHT } from '../../../globals';
import moment from 'moment';
import lodash from 'lodash';
import HeaderCard from './HeaderCard';
import TabSection from './TabSection';
import { vehicleRequestsRoute } from 'src/routing/routeConstants';
import GenericHoc from 'src/common/generic-hoc';
import { HocOptions } from 'src/common/generic-hoc.types';

const styles = (theme) => ({
  mainDiv: {
    flex: '1 1 0',
    padding: '0 16px 16px 16px',
    height: `calc( 100vh - ${NAVBAR_HEIGHT}px)`,
  },
  backAndSearch: {
    margin: '20px 10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  icons: {
    margin: '0px 5px',
    cursor: 'pointer',
  },
  container: {
    padding: '15px 12px',
    margin: '10px 12px',
    backgroundColor: '#ffffff',
    border: '1px solid #D9D9D9',
    borderRadius: '4px',
  },
  hint: {
    fontSize: '12px',
    color: '#595959',
    fontWeight: 400,
    margin: '12px 0',
  },
  content: {
    fontSize: '14px',
    color: '#262626',
    fontWeight: 500,
  },
  lightenLabel: {
    color: '#595959',
    paddingTop: 3,
    fontSize: 11,
  },
  refreshButton: {
    padding: '0 8px',
    marginLeft: 10,
  },
  tableContainer: {
    background: 'white',
    '& .ant-btn': {
      marginLeft: 5,
    },
    margin: '20px 12px',
    flexGrow: 1,
    overflowY: 'scroll',
    height: '80vh',
  },
  cameraIcon: {
    marginLeft: 10,
    color: '#085492',
  },
  actionButton: {
    marginLeft: 10,
  },
  status: {
    textTransform: 'capitalize',
  },
  leftSpace: {
    marginRight: '5px',
  },
  circle: {
    display: 'inline-block',
    borderRadius: '100%',
    marginRight: '5px',
    height: '12px',
    width: '12px',
  },
  checkedInCircle: {
    backgroundColor: '#EAAB0B',
  },
  checkedOutCircle: {
    backgroundColor: '#56D001',
  },
  secondaryStopTable: {
    margin: '15px 0',
  },
  red: {
    backgroundColor: '#FF7979',
  },
  green: {
    backgroundColor: '#c1e0d1',
  },
  infoIcon: {
    marginLeft: '8px',
    color: '#085492',
  },
  verticalSpacing: {
    marginTop: '0.5rem',
  },
});

const PRIMARY_TRIP = 'primary';
const SECONDARY_TRIP = 'secondary';
const DIRECT_TRIP = 'direct';
class DetailsPage extends React.Component<any, any> {
  state = {
    activeUpdatesList: [],
    error: false,
    isLoading: true,
    isMapView: false,
    defaultMetadata: {},
    metadataConfig: {
      tabs_to_show: [],
      actions_to_show: [],
      headers_to_show: [],
    },
    refreshInterval: null,
    actionList: [],
    headerList: [],
    columnList: [],
    updatesList: [],
    taskColumnList: [],
    currentActiveTab: '',
    isViewPending: true,
    isTaskViewPending: true,
    isAssignRiderModalVisible: false,
    isAssignVehicleModalVisible: false,
    isDeleteTaskModalVisible: false,
    isMoveCNModalVisible: false,
    isDeleteTripModalVisible: false,
    isUnfreezeTripModalVisible: false,
    isOptimiseRouteModalVisible: false,
    isDeleteStopModalVisible: false,
    isConsignmentColumnVisible: false,
    isStopHistoryModalVisible: false,
    isReadingImageModalVisible: false,
    isReorderTasks: false,
    readingImage: 'Start',
    ReadingImageUrl: '',
    selectedTripId: this.props.match.params.tripId,
    selectedTaskNumber: '',
    selectedTaskType: '',
    selectedCNNumber: '',
    selectedStopString: '',
    stopHistory: [],
    dataSource: [],
    taskList: [],
    taskConsignmentData: [],
    confirmLoading: false,
    taskType: undefined,
    rowExpanded: false,
    liveComponentForceUpdate: 0,
    data: {
      tripDetails: {
        id: undefined,
        organisation_reference_number: null,
        is_complete: undefined,
        hub_id: undefined,
        hub_name: undefined,
        created_at: undefined,
        type: undefined,
        worker_id: undefined,
        worker_name: undefined,
        vehicle_registration_number: undefined,
        incomplete_task_count: 0,
        status: undefined,
        updated_at: undefined,
        start_km_reading: undefined,
        end_km_reading: undefined,
        start_reading_image: undefined,
        end_reading_image: undefined,
        alertid: null,
        alertrefid: null,
        attempted_task_count: 0,
        delivered_task_count: 0,
        end_time: null,
        incomplete_tasks: [],
        incomplete_tasks_pickup: [],
        medium_id: undefined,
        organisation_id: undefined,
        route: '',
        stage: null,
        stage_history: null,
        start_time: null,
        incomplete_delivery_task_count: null,
        incomplete_pickup_task_count: null,
        pickedup_task_count: null,
        notpickedup_task_count: null,
        total_task_count: null,
        created_by: null,
        secondary_trips_count: null,
        primary_organisation_reference_number: null,
        primary_hub_name: null,
        trip_type: null,
        scheduled_at: undefined,
        vehicle_make: undefined,
        service_time_mins: undefined,
        volume: undefined,
        cod_value: undefined,
        vehicle_service_time_mins: undefined,
        ewb_status: undefined,
        scheduled_worker_name: undefined,
        scheduled_vehicle_registration_number: undefined,
        vehicle_make_id: undefined,
        hub_type: undefined,
        volume_capacity: undefined,
        weight_capacity: undefined,
        vehicle_volume_utilisation: undefined,
        vehicle_weight_utilisation: undefined,
        weight: undefined,
        extra_details: {
          is_direct_dispatch_to_seller: false,
          third_party_vendor_id: undefined,
        },
        trip_events: [],
        estimated_distance_km: undefined,
        estimated_time_seconds: undefined,
        simulated_start_time: undefined,
        simulated_end_time: undefined,
        simulated_aerial_trip_duration: undefined,
        freight_type: '',
        vehicle_vendor_name: '',
        vehicle_master_vendor_name: undefined,
        vehicle_master_vendor_id: undefined,
        assigned_vendors: [],
        creation_source: '',
      },
      consignmentDetails: {
        incomplete: [],
        complete: [],
      },
      taskDetails: {
        incomplete: [],
        complete: [],
      },
      plannedTaskDetails: [],
      secondaryDrops: [],
      sequenceDetails: [
        {
          sequence_number: 1,
          sequence_string: '',
          address: '',
          checkin_checkout_count: 0,
          checkin_checkout_status: '',
          checkin_checkout_status_history: [],
          checkin_event_time: 0,
          checkout_event_time: 0,
          consignments: [],
        },
      ],
    },
    isVendorDetailsModalVisible: false,
    isAddCNModalVisible: false,
    isTaskPickup: false,
    isReorderStops: false,
    isReorderCN: false,
    isStartEndTrip: false,
    tripActionType: null,
    defaultReading: '',
    pieceDetailsModalVisible: false,
    pieceDetails: {
      pieceDetailsData: [],
      selectedReferenceNumber: undefined,
      ndrReason: undefined,
    },
    selectedStopRowKeys: [],
    selectedTaskRowKeys: [],
    isBulkDeleteCNModalVisible: false,
    isBulkDeleteStopModalVisible: false,
    isBulkDeleteTaskModalVisible: false,
    vehicleMakeId: undefined,
    isSchedule: false,
    isValidateConsignmentsLoading: false,
    isApplyExceptionModalVisible: false,
    exceptionModalType: false,
    exceptionModalTitle: '',
    exceptionModalButtonText: '',
    isSimulateEtaModalVisible: false,
    isErrorModalVisible: false,
    simulationTimeOnOptimiseRoute: true,
    failureArray: [],
    fullHeadersList: [],
  };

  componentDidMount = () => {
    this.fetchDefaultMetadata();
    this.fetchTrip();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.match?.params?.tripId !== this.props.match?.params?.tripId) {
      this.fetchTrip();
    }
  }

  prepareUpdates = (tabs, activeTab) => {
    const updates = {};
    tabs.forEach((tab) => {
      updates[tab.tab_header] = tab.keys_to_show;
    });
    return updates[activeTab];
  };

  prepareHeaderList = (headers, tabs) => {
    if (!tabs) return headers;
    const tab = tabs.find((x) => {
      return x.tab_header === 'Trip Details';
    });
    let columns = lodash.get(tab, 'details[0].columns', null);
    columns = columns.map((ele) => {
      return { id: ele.id, show_on_main_dashboard: false };
    });
    headers = headers.map((ele) => {
      return { id: ele.id, show_on_main_dashboard: true };
    });
    return [...headers, ...columns];
  };

  prepareFullHeadersList = (headers, tabs) => {
    if (!tabs) return headers;
    const tab = tabs.find((x) => {
      return x.tab_header === 'Trip Details';
    });
    const columns = lodash.get(tab, 'details[0].columns', null);
    if (!columns) return headers;
    const toRet = [...headers, ...columns];
    return toRet.map((x) => {
      return { ...x, label: x.pretty_name };
    });
  };

  fetchDefaultMetadata = async () => {
    const response = await getTripDetailsMetadata();
    if (!response.isSuccess) {
      message.error(response.errorMessage);
      return;
    }
    const tripDetailsMetadata = response?.data?.default_trip_details_metadata;
    const activeTab = 'Consignments';
    const tabs = tripDetailsMetadata?.tabs_to_show || [];
    const consignmentTabMetadata =
      tabs?.filter((tab) => {
        return tab.tab_header === 'Consignments';
      }) || [];
    const taskTabMetadata =
      tabs?.filter((tab) => {
        return tab.tab_header === 'Tasks';
      }) || [];
    const columnList = lodash.get(consignmentTabMetadata[0], 'details[0].columns') || [];
    const taskColumnList = lodash.get(taskTabMetadata[0], 'details[0].columns') || [];
    const actionList = tripDetailsMetadata?.actions_to_show || [];
    const updatesList = this.prepareUpdates(tabs, activeTab);
    const headerList = this.prepareHeaderList(tripDetailsMetadata?.headers_to_show, tabs) || [];
    const fullHeadersList = this.prepareFullHeadersList(
      response?.data?.default_trip_details_metadata?.headers_to_show,
      response?.data?.default_trip_details_metadata?.tabs_to_show,
    );
    const activeUpdatesList = updatesList?.filter((update) => update.isActive) || [];
    this.setState({
      defaultMetadata: response?.data?.data?.default_trip_details_metadata,
      currentActiveTab: activeTab,
      columnList,
      taskColumnList,
      actionList,
      updatesList,
      headerList,
      metadataConfig: tripDetailsMetadata,
      fullHeadersList,
      activeUpdatesList,
    });
    this.autoRefreshTrip(activeUpdatesList);
  };

  handleCurrentActiveTab = (tab) => {
    this.setState({ currentActiveTab: tab });
  };

  getUpdatedHeadersAndTripColumns = (globalActions, globalHeaders) => {
    const headers = globalHeaders.filter((x) => {
      return x.show_on_main_dashboard === true;
    });
    const tripColumns = globalHeaders.filter((x) => {
      return !x.show_on_main_dashboard;
    });

    const fullHeadersList = { ...this.state.fullHeadersList };

    const updatedHeaders = headers.map((ele) => {
      const head = fullHeadersList.find((x) => x.id === ele.id);
      if (!head) return null;
      const { label, ...headRest } = head;
      return headRest;
    });
    const updatedTripColumns = tripColumns.map((ele) => {
      const col = fullHeadersList.find((x) => x.id === ele.id);
      if (!col) return null;
      const { label, ...colRest } = col;
      return colRest;
    });
    return { updatedHeaders, updatedTripColumns };
  };

  onRefreshClick = async () => {
    this.fetchTrip();
  };

  fetchTrip = async () => {
    this.setState({ isLoading: true, error: false });
    const response = await getTripDetails({
      tripReferenceNumber: this.props.match.params.tripId,
    });
    if (!response.isSuccess) {
      this.setState({ isLoading: false, error: response.errorMessage });
      return;
    }
    const res = response.data;

    const dataSource =
      res.tripDetails.status === 'completed'
        ? res.consignmentDetails.complete.concat(res.consignmentDetails.incomplete)
        : res.consignmentDetails.incomplete;
    res.tripDetails.extra_details = res.tripDetails.extra_details || {};
    res.taskDetails = res.taskDetails || [];
    const getTaskType = dataSource?.filter((record) => record.task_type === 'pickup');
    res.sequenceDetails = res.sequenceDetails || [];
    this.setState(
      {
        dataSource,
        data: res,
        error: false,
        isViewPending: true,
        taskType: getTaskType?.length ? 'Tasks' : 'Consignments',
        selectedTripId: res.tripDetails.id,
        isTaskViewPending: true,
        taskList: res.taskDetails.incomplete,
      },
      () => {
        this.setState({
          isLoading: false,
        });
      },
    );
  };

  fetchTripRefresh = async () => {
    let res: any = [];
    const locationStateData = lodash.get(this.props, 'location.state.data', false);
    if (locationStateData) {
      res = locationStateData.data;
    } else {
      const response = await getTripDetails({
        tripReferenceNumber: this.props.match.params.tripId,
      });
      if (!response.isSuccess) {
        this.setState({ isLoading: false, error: response.errorMessage });
        return;
      }
      res = response.data.data;
    }
    const dataSource =
      res.tripDetails.status === 'completed'
        ? [...res.consignmentDetails.complete, ...res.consignmentDetails.incomplete]
        : res.consignmentDetails.incomplete;
    res.tripDetails.extra_details = res.tripDetails.extra_details || {};
    res.taskDetails = res.taskDetails || [];
    const getTaskType = dataSource?.filter((record) => record.task_type === 'pickup');
    res.sequenceDetails = res.sequenceDetails || [];
    this.setState({
      dataSource,
      data: res,
      isViewPending: true,
      taskType: getTaskType?.length ? 'Tasks' : 'Consignments',
      selectedTripId: res.tripDetails.id,
      isTaskViewPending: true,
      taskList: res.taskDetails.incomplete,
    });
  };

  redirectToVehicleRequests = () => {
    const { history } = this.props;
    history.push(vehicleRequestsRoute);
  };

  autoRefreshTrip = async (updates) => {
    const refreshUpdate = updates.find((update) => update.id === 'auto_refresh_duration_in_sec');
    if (refreshUpdate) {
      const refreshFrequency = refreshUpdate.value
        ? parseInt(refreshUpdate.value, 10) * 1000
        : 10000;
      if (refreshUpdate.isActive) {
        if (this.state.refreshInterval) {
          clearInterval(this.state.refreshInterval);
        }
        const refreshInterval = setInterval(() => {
          this.fetchTripRefresh();
          this.setState((prevState) => ({
            ...prevState,
            liveComponentForceUpdate: prevState.liveComponentForceUpdate + 1,
          }));
        }, refreshFrequency);
        this.setState({
          refreshInterval,
        });
      } else if (this.state.refreshInterval) {
        clearInterval(this.state.refreshInterval);
      }
    }
  };

  onViewTaskPendingChange = (checked) => {
    const { data } = this.state;
    let filteredData = [];
    if (checked) {
      filteredData = [...data.taskDetails.incomplete];
    } else {
      filteredData = [...data.taskDetails.complete.concat(data.taskDetails.incomplete)];
    }
    this.setState({
      isTaskViewPending: checked,
      taskList: filteredData,
    });
  };

  onViewPendingChange = (checked) => {
    const { data } = this.state;
    let filteredData = [];
    if (checked) {
      filteredData = [...data.consignmentDetails.incomplete];
    } else {
      filteredData = [
        ...data.consignmentDetails.complete.concat(data.consignmentDetails.incomplete),
      ];
    }
    this.setState({
      isViewPending: checked,
      dataSource: filteredData,
    });
  };

  showModal = (modalToSetVisible: any) => {
    this.setState({
      [modalToSetVisible]: true,
    });
  };

  closeModals = (isSuccess: any) => {
    this.setState({
      isTaskPickup: false,
      isAddCNModalVisible: false,
      isMoveCNModalVisible: false,
      isAssignRiderModalVisible: false,
      isAssignVehicleModalVisible: false,
      isDeleteTaskModalVisible: false,
      isDeleteStopModalVisible: false,
      isStopHistoryModalVisible: false,
      isReadingImageModalVisible: false,
      isReorderStops: false,
      isReorderCN: false,
      pieceDetailsModalVisible: false,
      isStartEndTrip: false,
      isDeleteTripModalVisible: false,
      isUnfreezeTripModalVisible: false,
      isBulkDeleteCNModalVisible: false,
      isBulkDeleteStopModalVisible: false,
      isApplyExceptionModalVisible: false,
      isBulkDeleteTaskModalVisible: false,
      isSimulateEtaModalVisible: false,
      isErrorModalVisible: false,
      isConsignmentColumnVisible: false,
      isVendorDetailsModalVisible: false,
      isOptimiseRouteModalVisible: false,
    });
    if (isSuccess) {
      this.fetchTrip();
    }
  };

  showPieceDetailsModal = (record) => {
    this.setState({
      pieceDetailsModalVisible: true,
      pieceDetails: {
        pieceDetailsData: record.pieces_detail,
        selectedReferenceNumber: record.reference_number,
        ndrReason: record.delivery_failure_reason,
      },
    });
  };

  generateDataColumnsTracking = () => {
    const { metadataConfig } = this.state;
    const { t } = this.props;
    const columnData: any = [];
    const tabHeader = metadataConfig?.tabs_to_show?.find(
      (tab) => tab.tab_header === 'Trip Tracking',
    );
    const indexList = tabHeader?.details?.[0]?.columns || [];
    indexList?.forEach((item) => {
      const itemToPush = {};
      itemToPush['title'] = t(item.pretty_name);
      itemToPush['dataIndex'] = item.id;
      itemToPush['key'] = item.id;
      itemToPush['width'] = 60;
      if (item.id === 'event_time') {
        itemToPush['render'] = (x) => {
          return x ? moment(x).format('DD/MM/YYYY, HH:mm') : null;
        };
      }

      if (item.id === 'type') {
        itemToPush['render'] = (x, record) => {
          return record['event_string'] ?? '';
        };
      }
      columnData.push(itemToPush);
    });

    return columnData;
  };

  generateDataColumns = () => {
    const { data, isViewPending, isReorderCN, taskType, metadataConfig } = this.state;
    const { classes, viewType } = this.props;
    const { t } = this.props;
    const columnData: any = [];
    const tabHeader = metadataConfig?.tabs_to_show?.find(
      (tab) => tab.tab_header === 'Consignments',
    );
    const indexList = tabHeader?.details?.[0]?.columns;
    indexList?.forEach((item) => {
      const itemToPush = {};
      itemToPush['title'] = t(item.pretty_name);
      itemToPush['dataIndex'] = item.id;
      itemToPush['width'] = 100;
      itemToPush['key'] = item.id;

      if (item.id === 's_no') {
        itemToPush['render'] = (x, record, index) => {
          return <div>{index + 1}</div>;
        };
      }

      if (item.id === 'status') {
        itemToPush['render'] = (x, record) => {
          return (
            <div style={{ minWidth: 140 }}>
              <span className={classes.status}>{getRetailConsignmentStatus(x)}</span>
              <div className={classes.lightenLabel}>
                {record.last_main_event_time ? formatDateTime(record.last_main_event_time) : null}
              </div>
            </div>
          );
        };
      }
      if (item.id === 'no_of_pieces') {
        itemToPush['render'] = (x, record) => {
          const pieces = record.pieces_detail;
          return pieces && pieces.length > 0 ? (
            <div>
              {pieces.length}
              <InfoCircleOutlined
                style={{ marginLeft: 8, color: '#085492', fontSize: 14 }}
                onClick={() => this.showPieceDetailsModal(record)}
              />
            </div>
          ) : (
            0
          );
        };
      }
      if (item.id === 'consignment_type') {
        itemToPush['render'] = (x, record) => {
          return x ? getConsignmentTypePrettyName(x) : 'Delivery';
        };
      }
      if (item.id === 'reference_number') {
        itemToPush['title'] = t(taskType === 'Tasks' ? 'Task #' : item.pretty_name);
        itemToPush['render'] = (x, record) => {
          return x;
        };
      }
      if (item.id === 'in_trip_status') {
        itemToPush['render'] = (x, record) => {
          const { status, time } = getRetailInTripConsignmentStatus(record);
          return (
            <div>
              <span style={{ textTransform: 'capitalize' }}>{status}</span>
              <div className={classes.lightenLabel}>{formatDateTime(time)}</div>
            </div>
          );
        };
      }
      if (item.id === 'simulated_eta') {
        itemToPush['width'] = 100;
        itemToPush['render'] = (x, record) => {
          return record.simulated_eta ? (
            <span>{`${moment(record.simulated_eta).format('YYYY-MM-DD HH:mm')}`}</span>
          ) : null;
        };
      }
      if (item.id === 'delivery_time_slot_start' || item.id === 'delivery_time_slot_end') {
        itemToPush['width'] = 100;
        itemToPush['render'] = (x, record) => {
          return x ? <span>{`${moment(parseInt(x, 10)).format('HH:mm')}`}</span> : null;
        };
      }
      if (item.id === 'eta_breached') {
        itemToPush['width'] = 100;
        itemToPush['render'] = (x, record) => {
          return x ? 'Yes' : 'No';
        };
      }
      if (item.id === 'task_type') {
        itemToPush['width'] = 100;
        itemToPush['render'] = (x, record) => (x ? getTaskTypePrettyName(x) : null);
      }
      if (item.id === 'volume') {
        itemToPush['width'] = 100;
        itemToPush['render'] = (x, record) => (this.isValidVal(x) ? <span>{x}</span> : null);
      }
      if (item.id === 'service_time_mins') {
        itemToPush['render'] = (x, record) => (this.isValidVal(x) ? <span>{x}</span> : null);
      }
      if (item.id === 'customer_reference_number') {
        itemToPush['render'] = (x, record) => {
          return x ? <span style={{ wordBreak: 'break-all' }}>{x}</span> : '-';
        };
      }
      if (item.id === 'receiver_address') {
        itemToPush['width'] = 250;
      }
      if (item.id === 'arrival_time') {
        itemToPush['render'] = (x, record) => {
          return x ? <span>{`Checked-In ${moment(x).format('YYYY-MM-DD, HH:mm')}`}</span> : null;
        };
      }
      if (
        !(this.state.data.tripDetails.trip_type === PRIMARY_TRIP && item.id === 'in_trip_status')
      ) {
        columnData.push(itemToPush);
      }
    });
    return columnData;
  };

  renderReadingImage = (type) => {
    const { data } = this.state;
    if (type === 'start') {
      this.setState({
        ReadingImageUrl: data.tripDetails.start_reading_image,
        readingImage: 'Start',
      });
    } else {
      this.setState({
        ReadingImageUrl: data.tripDetails.end_reading_image,
        readingImage: 'End',
      });
    }
    this.setState({
      isReadingImageModalVisible: true,
    });
  };

  renderInfoContainer = (hint: any, content: any) => {
    const { classes } = this.props;
    return (
      <Col span={4} className={classes.infoBox}>
        <div className={classes.hint}>{hint}</div>
        <div className={classes.content}>{content}</div>
      </Col>
    );
  };

  isValue = (data) => {
    if (Number.isInteger(data)) {
      return data;
    }
    return 'Not Available';
  };

  secondaryDropColumns = () => {
    const { metadataConfig } = this.state;
    const tabHeader = metadataConfig?.tabs_to_show?.find((tab) => tab.tab_header === 'Drops');
    const columns = tabHeader?.details?.[0]?.columns;
    const columnsToShow = columns?.map((column) => {
      return {
        title: column.pretty_name,
        dataIndex: column.id,
        key: column.id,
      };
    });
    return columnsToShow;
  };

  secondaryDropsRenderer = (record) => {
    const columns = [
      { title: 'Reference Number', dataIndex: 'reference_number', key: 'reference_number' },
      {
        title: 'Address',
        dataIndex: 'consignment_address_string',
        key: 'consignment_address_string',
      },
    ];
    return <Table dataSource={record.consignments} columns={columns} pagination={false} />;
  };

  generateStopColumns = () => {
    const { data, isViewPending, isReorderStops, metadataConfig } = this.state;
    const { classes, viewType, t } = this.props;
    const { sequenceDetails } = data;
    const columnData: any = [];
    const tabHeader = metadataConfig?.tabs_to_show?.find((tab) => tab.tab_header === 'Stops');
    const indexList = tabHeader?.details?.[0]?.columns;
    indexList?.forEach((item) => {
      const itemToPush = {};
      itemToPush['title'] = t(item.pretty_name);
      itemToPush['dataIndex'] = item.id;
      itemToPush['width'] = 100;
      itemToPush['key'] = item.id;

      if (item.id === 'actions') {
        if (isReorderStops) {
          return;
        }
        if (data.tripDetails.status === 'completed') return;
        if (data.tripDetails.status === 'started') return;
      }

      if (item.id === 'delivery_time_slot_start' || item.id === 'delivery_time_slot_end') {
        itemToPush['width'] = 100;
        itemToPush['render'] = (x, record) => {
          return record[item.id] ? (
            <span>{`${moment(parseInt(record[item.id], 10)).format('HH:mm')}`}</span>
          ) : null;
        };
      }

      if (item.id === 'stop_id') {
        itemToPush['render'] = (x, record) => {
          return <span>Stop {record['sequence_number']}</span>;
        };
      }

      if (item.id === 'checkin_checkout_status') {
        itemToPush['render'] = (x, record) => {
          return (
            <div>
              {x === 'checkin' && (
                <div>
                  <div>
                    <div className={classNames(classes.circle, classes.checkedInCircle)} />
                    <span>Checked-In</span>
                    <InfoCircleOutlined
                      style={{ marginLeft: 8, color: '#085492', fontSize: 14 }}
                      onClick={() => {
                        this.setState({
                          isStopHistoryModalVisible: true,
                          stopHistory:
                            sequenceDetails[record.sequence_number - 1]
                              .checkin_checkout_status_history,
                        });
                      }}
                    />
                  </div>
                  <div className={classes.lightenLabel}>
                    {record.checkin_event_time && formatDateTime(record.checkin_event_time)}
                  </div>
                </div>
              )}
              {x === 'checkout' && (
                <div>
                  <div>
                    <div className={classNames(classes.circle, classes.checkedOutCircle)} />
                    <span>Checked-Out</span>
                    <InfoCircleOutlined
                      style={{ marginLeft: 8, color: '#085492', fontSize: 14 }}
                      onClick={() => {
                        this.setState({
                          isStopHistoryModalVisible: true,
                          stopHistory:
                            sequenceDetails[record.sequence_number - 1]
                              .checkin_checkout_status_history,
                        });
                      }}
                    />
                  </div>
                  <div className={classes.lightenLabel}>
                    {record.checkout_event_time && formatDateTime(record.checkout_event_time)}
                  </div>
                </div>
              )}
            </div>
          );
        };
      }
      columnData.push(itemToPush);
    });
    return columnData;
  };

  generateTaskColumns = () => {
    const { data, isViewPending, isReorderTasks, metadataConfig } = this.state;
    const { classes, viewType, t } = this.props;
    const columnData: any = [];
    const tabHeader = metadataConfig?.tabs_to_show?.find((tab) => tab.tab_header === 'Tasks');
    const indexList = tabHeader?.details?.[0]?.columns;
    indexList?.forEach((item) => {
      const itemToPush = {};
      itemToPush['title'] = t(item.pretty_name);
      itemToPush['dataIndex'] = item.id;
      itemToPush['width'] = 100;
      itemToPush['key'] = item.id;

      if (item.id === 'expected_cn') {
        itemToPush['render'] = (x, record) => {
          const expectedCNLength = record.consignment_list?.length;
          return <div>{expectedCNLength}</div>;
        };
      }

      if (item.id === 'picked_cn') {
        itemToPush['render'] = (x, record) => {
          const pickedCNLength = record.consignment_success_list?.length;
          return (
            <div>
              {pickedCNLength}
              {pickedCNLength > 0 ? (
                <InfoCircleOutlined
                  className={classes.infoIcon}
                  onClick={() => {
                    this.setState({
                      isConsignmentColumnVisible: true,
                      taskConsignmentData: record.consignment_success_list,
                    });
                  }}
                />
              ) : null}
            </div>
          );
        };
      }

      if (item.id === 'pickup_time_slot_start') {
        itemToPush['render'] = (x, record) => {
          return (
            <div className={classes.lightenLabel}>
              {formatDateTime(record['time_slot_start'])} -{formatDateTime(record['time_slot_end'])}
            </div>
          );
        };
      }
      if (item.id === 'pickup_address_line_1') {
        itemToPush['render'] = (x, record) => {
          return (
            <span>
              {record.address_line_1} {record.address_line_2}
            </span>
          );
        };
      }
      if (item.id === 'customer_name_pickup') {
        itemToPush['render'] = (x, record) => {
          return <span>{record['customer_name']}</span>;
        };
      }
      if (item.id === 'pickup_pincode') {
        itemToPush['render'] = (x, record) => {
          return <span>{record['pincode']}</span>;
        };
      }
      if (item.id === 'pickup_zone') {
        itemToPush['render'] = (x, record) => {
          return <span>{record['zone']}</span>;
        };
      }

      if (item.column_id === 'task_type') {
        itemToPush['width'] = 100;
        itemToPush['render'] = (x, record) => (x ? getTaskTypePrettyName(x) : null);
      }

      columnData.push(itemToPush);
    });
    return columnData;
  };

  secondaryStopRenderer = (record) => {
    const { classes } = this.props;
    return (
      <Table
        className={classes.secondaryStopTable}
        dataSource={record.consignments}
        columns={this.generateDataColumns()}
        pagination={false}
        rowClassName={(record, index) => {
          return record.eta_breached ? classes.red : classes.green;
        }}
      />
    );
  };

  isValidVal = (val) => {
    if (Number.isInteger(val) || this.isFloat(val)) {
      return val;
    }
    return 'Not Available';
  };

  isFloat = (n) => {
    return Number(n) === n && n % 1 !== 0;
  };

  getScrollWidth = () => {
    const columns = this.generateDataColumns();
    return columns.reduce((acc, cur) => {
      return acc + (cur.width || 150);
    }, 0);
  };

  renderVehicleRegNo = () => {
    const { data } = this.state;
    const { allowCrossVendorAssignment } = this.props;
    const { tripDetails } = data;
    const { vehicle_registration_number, vehicle_master_vendor_name,
      vehicle_master_vendor_id } = tripDetails;
    const third_party_vendor_id = tripDetails.extra_details?.third_party_vendor_id;
    const isCrossVendor = allowCrossVendorAssignment &&
      vehicle_master_vendor_id && third_party_vendor_id &&
      vehicle_master_vendor_id !== third_party_vendor_id;
    return (
      <div>
        {vehicle_registration_number}
        {isCrossVendor && (
          <CrossVendorIndicator masterVendorName={vehicle_master_vendor_name || ''} />
        )}
      </div>
    );
  };

  renderEWBStatus = (x) => {
    const { classes, t } = this.props;
    return x === 'success' ? (
      <span>
        <CheckCircleFilled style={{ color: '#008000' }} className={classes.leftSpace} />
        {t('Success')}
      </span>
    ) : (
      <span>
        <CloseCircleFilled style={{ color: '#EC544A' }} className={classes.leftSpace} />
        {t('Failed')}
      </span>
    );
  };

  renderScheduledDriver = () => {
    const { classes } = this.props;
    const { data } = this.state;
    const { tripDetails } = data;
    const { worker_name, scheduled_worker_name } = tripDetails;
    return <div>{!worker_name ? scheduled_worker_name : '---'}</div>;
  };

  renderScheduledVehicle = () => {
    const { classes } = this.props;
    const { data } = this.state;
    const { tripDetails } = data;
    const { vehicle_registration_number, scheduled_vehicle_registration_number } = tripDetails;
    return (
      <div>{!vehicle_registration_number ? scheduled_vehicle_registration_number : '---'}</div>
    );
  };

  getTotalTripTime = (
    estimated_time_seconds,
    service_time_mins,
    simulated_aerial_trip_duration,
  ) => {
    let totalTripTime = null;

    const serviceTimeMins = this.isValidVal(service_time_mins);
    if (serviceTimeMins !== 'Not Available') {
      totalTripTime = estimated_time_seconds
        ? parseMinuteSeconds(estimated_time_seconds + service_time_mins * 60)
        : null;
    } else {
      totalTripTime = estimated_time_seconds ? parseMinuteSeconds(estimated_time_seconds) : null;
    }

    return totalTripTime;
  };

  editKmReadingClick = (params) => {
    const { tripActionType, defaultReading } = params;

    this.setState({
      isStartEndTrip: true,
      tripActionType,
      defaultReading,
    });
  };

  renderUtilisationData = (value) => {
    return <div>{value || '-'}</div>;
  };

  disabledDate = (current) => {
    return current && current <= moment().subtract(1, 'days');
  };

  getPropsByHeader = (tabHeader) => {
    const { dataSource, taskList, data } = this.state;
    const { classes } = this.props;

    const CNRowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys });
      },
    };

    const taskRowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedTaskRowKeys: selectedRowKeys });
      },
    };

    const stopRowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedStopRowKeys: selectedRowKeys });
      },
    };

    const consignmentProps = {
      rowKey: (record: any) => record['reference_number'],
      scroll: { x: this.getScrollWidth() },
      dataSource,
      columns: this.generateDataColumns(),
      rowClassName: classes.green,
    };

    const taskProps = {
      rowKey: (record: any) => record['task_reference_number'],
      pagination: false,
      dataSource: taskList || [],
      columns: this.generateTaskColumns(),
    };

    const stopsProps = {
      rowKey: (record: any) => record['sequence_string'],
      pagination: false,
      dataSource: data.sequenceDetails || [],
      columns: this.generateStopColumns(),
      scroll: this.state.rowExpanded && { x: this.getScrollWidth() },
      expandable: {
        expandedRowRender: (record) => this.secondaryStopRenderer(record),
        onExpand: (expanded) => this.setState({ rowExpanded: expanded }),
      },
    };

    const dropsProps = {
      rowKey: (record: any) => record['reference_number'],
      pagination: false,
      dataSource: data.secondaryDrops || [],
      columns: this.secondaryDropColumns(),
      expandedRowRender: this.secondaryDropsRenderer,
    };

    const tripTrackingProps = {
      pagination: false,
      dataSource: data.tripDetails?.trip_events || [],
      columns: this.generateDataColumnsTracking(),
    };

    switch (tabHeader) {
      case 'Consignments':
        return consignmentProps;
      case 'Tasks':
        return taskProps;
      case 'Stops':
        return stopsProps;
      case 'Drops':
        return dropsProps;
      case 'Trip Tracking':
        return tripTrackingProps;
      default:
        return {};
    }
  };

  isBooleanVal = (val) => {
    return val ? <div>TRUE</div> : <div>FALSE</div>;
  };

  getCustomDetailsCard = (column, data) => {
    const { classes } = this.props;

    let dataToRender = {
      hint: '',
      content: <></> || '',
    };
    switch (column.id) {
      case 'status':
        dataToRender = {
          hint: column.pretty_name,
          content: tripStatusPrettyNames(data[column.id]),
        };
        break;
      case 'planning_hub':
        dataToRender = {
          hint: data['trip_type'] !== SECONDARY_TRIP ? 'Planning Hub' : 'Hub',
          content: data['hub_name'],
        };
        break;
      case 'created_at':
      case 'start_time':
      case 'end_time':
      case 'updated_at':
      case 'scheduled_at':
      case 'simulated_start_time':
      case 'simulated_end_time':
        dataToRender = {
          hint: column.pretty_name,
          content: formatDateTime(data[column.id]),
        };
        break;
      case 'delivered_task_count':
      case 'attempted_task_count':
      case 'pickedup_task_count':
      case 'notpickedup_task_count':
      case 'incomplete_delivery_task_count':
      case 'incomplete_pickup_task_count':
      case 'total_task_count':
        dataToRender = {
          hint: column.pretty_name,
          content: this.isValue(data[column.id]),
        };
        break;
      case 'start_km_reading':
        dataToRender = {
          hint: column.pretty_name,
          content: (
            <div>
              {data[column.id] || 'Not Available'}
              {data[column.id] && data['start_reading_image'] ? (
                <CameraFilled
                  className={classes.cameraIcon}
                  onClick={() => this.renderReadingImage('start')}
                />
              ) : null}
            </div>
          ),
        };
        break;
      case 'end_km_reading':
        dataToRender = {
          hint: column.pretty_name,
          content: (
            <div>
              {data[column.id] || 'Not Available'}
              {data[column.id] && data['end_reading_image'] ? (
                <CameraFilled
                  className={classes.cameraIcon}
                  onClick={() => this.renderReadingImage('end')}
                />
              ) : null}
            </div>
          ),
        };
        break;
      case 'ewb_status':
        dataToRender = {
          hint: column.pretty_name,
          content: this.renderEWBStatus(data[column.id]),
        };
        break;
      case 'volume':
      case 'weight':
      case 'volume_capacity':
      case 'weight_capacity':
      case 'vehicle_volume_utilisation':
      case 'vehicle_weight_utilisation':
        dataToRender = {
          hint: column.pretty_name,
          content: this.renderUtilisationData(data[column.id]),
        };
        break;
      case 'consignment_volume':
        dataToRender = {
          hint: column.pretty_name,
          content: this.renderUtilisationData(data['volume']),
        };
        break;
      case 'cod_value':
      case 'service_time_mins':
      case 'vehicle_service_time_mins':
        dataToRender = {
          hint: column.pretty_name,
          content: this.isValidVal(data[column.id]),
        };
        break;
      case 'scheduled_worker_name':
        dataToRender = {
          hint: column.pretty_name,
          content: this.renderScheduledDriver(),
        };
        break;
      case 'scheduled_vehicle_registration_number':
        dataToRender = {
          hint: column.pretty_name,
          content: this.renderScheduledVehicle(),
        };
        break;
      case 'estimated_distance_km':
        dataToRender = {
          hint: column.pretty_name,
          content: data[column.id] ? <div>{data[column.id]} km</div> : null,
        };
        break;
      case 'trip_type':
      case 'creation_source':
      case 'vehicle_make':
        dataToRender = {
          hint: column.pretty_name,
          content: data[column.id] ? (
            <div style={{ textTransform: 'capitalize' }}>{data[column.id]}</div>
          ) : null,
        };
        break;
      case '{estimated_time_seconds,service_time_mins}':
        dataToRender = {
          hint: column.pretty_name,
          content: this.getTotalTripTime(
            data['estimated_time_seconds'],
            data['service_time_mins'],
            data?.['simulated_aerial_trip_duration'],
          ),
        };
        break;
      case 'secondary_trips_count':
        if (data['trip_type'] !== DIRECT_TRIP) {
          if (data['trip_type'] === PRIMARY_TRIP) {
            dataToRender = {
              hint: column.pretty_name,
              content: data[column.id],
            };
          }
        }
        break;
      case 'primary_organisation_reference_number':
        if (data['trip_type'] !== DIRECT_TRIP) {
          if (data['trip_type'] !== PRIMARY_TRIP) {
            dataToRender = {
              hint: column.pretty_name,
              content: data[column.id],
            };
          }
        }
        break;
      case 'primary_hub_name':
        if (data['trip_type'] !== DIRECT_TRIP) {
          if (data['trip_type'] !== PRIMARY_TRIP) {
            dataToRender = {
              hint: column.pretty_name,
              content: data[column.id],
            };
          }
        }
        break;
      case 'total_amount':
        dataToRender = {
          hint: column.pretty_name,
          content: this.isValidVal(data['cod_value']),
        };
        break;
      case 'total_volume':
        dataToRender = {
          hint: column.pretty_name,
          content: this.isValidVal(data['volume']),
        };
        break;
      default:
        if (column.type === 'boolean') {
          dataToRender = {
            hint: column.pretty_name,
            content: this.isBooleanVal(data[column.id]),
          };
          break;
        }
        dataToRender = {
          hint: column.pretty_name,
          content: data[column.id],
        };
        break;
    }

    return dataToRender;
  };

  showWorkerName = () => {
    const { data } = this.state;
    const { tripDetails } = data;
    const { worker_name } = tripDetails;
    return <div>{worker_name}</div>;
  };

  render() {
    const { t } = this.props;
    if (this.state.error) {
      return (
        <div>
          <DocumentTitle title={t("Trip Details")} />
          <Navbar pageTitle={t("Trip Details")} />
          <Result
            status="error"
            title="Error"
            subTitle={this.state.error}
            extra={[
              <Button type="primary" onClick={this.redirectToVehicleRequests}>
                {t('Go To Vehicle Requests')}
              </Button>,
            ]}
          />
        </div>
      );
    }
    const { classes } = this.props;
    const {
      isLoading,
      data,
      isMapView,
      defaultMetadata,
      currentActiveTab,
      columnList,
      actionList,
      metadataConfig,
      taskColumnList,
      headerList,
      fullHeadersList,
      updatesList,
      activeUpdatesList,
    } = this.state;

    return (
      <div>
        <DocumentTitle title={t("Trip Manager Details")} />
        <Navbar pageTitle={t("Trip Manager Details")} />
        {isLoading ? (
          <Loader zIndex={100} />
        ) : (
          <div style={{ maxHeight: '100vh', overflowX: 'hidden' }}>
            <HeaderCard
              viewSource="trip details"
              fullHeadersList={fullHeadersList}
              columns={headerList}
              data={this.state.data.tripDetails}
              showWorkerName={this.showWorkerName}
              showVehicleRegNo={this.renderVehicleRegNo}
            />
            <div className={classes.tableContainer} style={{ display: 'flex' }}>
              <div
                style={{
                  width: isMapView ? '50%' : '100%',
                  overflowX: 'scroll',
                }}
              >
                <TabSection
                  tabs={metadataConfig?.tabs_to_show}
                  data={data}
                  reload={() => this.fetchTrip()}
                  isMapView={isMapView}
                  metadata={defaultMetadata}
                  currentActiveTab={currentActiveTab}
                  columnList={columnList}
                  taskColumnList={taskColumnList}
                  actionList={actionList}
                  headerList={headerList}
                  handleCurrentActiveTab={this.handleCurrentActiveTab}
                  getPropsByHeader={(tabHeader) => this.getPropsByHeader(tabHeader)}
                  getCustomDetailsCard={this.getCustomDetailsCard}
                  fullHeadersList={fullHeadersList}
                  updatesList={updatesList}
                  activeUpdatesList={activeUpdatesList}
                  autoRefreshTrip={this.autoRefreshTrip}
                  showUpdatesTripDetails={[]}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { allow_cross_vendor_vehicle_worker_assignment } = state.masterData;
  return {
    allowCrossVendorAssignment: allow_cross_vendor_vehicle_worker_assignment,
  };
};

const hocConfig: HocOptions = {
  connectRedux: {
    useRedux: true,
    mapStateToProps,
  },
  connectTranslession: true,
};

const DetailsPageStyled = withStyles(styles, { injectTheme: true })(DetailsPage);
export default GenericHoc(hocConfig)(DetailsPageStyled);
